// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"projects_signup_src_app_public_public_module_ts":"82a5711dca8ba296","projects_signup_src_app_public_signup_signup_module_ts":"e12d0da191d54392","quill":"b0b6bd8814f906a9"}[chunkId] + ".js";
};